/**
 * Cart drawer + pre-checkout upsell recommendations.
 */
(function () {
  function formatMoney(cents) {
    try {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents, window.themeVariables?.moneyFormat);
      }
    } catch (_) {}
    return (Number(cents) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function cartProductIds(el) {
    return (el.dataset.cartProductIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
  }

  async function fetchRecommendations(productId, intent, limit) {
    const url = `/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`;
    const res = await fetch(url);
    if (!res.ok) return [];
    const data = await res.json();
    return data.products || [];
  }

  function filterOutCart(products, inCart) {
    const set = new Set(inCart.map(String));
    return products.filter((p) => p.available && !set.has(String(p.id)));
  }

  async function loadUpsell(root) {
    const productId = root.dataset.productId;
    const limit = Number(root.dataset.limit || 3);
    const intent = root.dataset.intent || 'complementary';
    const fallback = root.dataset.fallbackIntent || 'related';
    const list = root.querySelector('[data-ac-cart-upsell-list]');
    if (!productId || !list) return;

    let products = filterOutCart(
      await fetchRecommendations(productId, intent, limit + 2),
      cartProductIds(root)
    );

    if (products.length < 1 && fallback !== intent) {
      products = filterOutCart(
        await fetchRecommendations(productId, fallback, limit + 2),
        cartProductIds(root)
      );
    }

    products = products.slice(0, limit);
    if (!products.length) {
      root.hidden = true;
      return;
    }

    list.innerHTML = products
      .map((p) => {
        const imgRaw = p.featured_image || p.images?.[0];
        const img = typeof imgRaw === 'string' ? imgRaw : imgRaw?.src || '';
        const variant = p.variants?.find((v) => v.available) || p.variants?.[0];
        if (!variant) return '';
        const priceCents = Number(variant.price);
        return `
          <article class="ac-cart-upsell__item">
            <a class="ac-cart-upsell__media" href="${p.url}">
              ${
                img
                  ? `<img src="${img}" alt="${String(p.title).replace(/"/g, '&quot;')}" width="72" height="90" loading="lazy">`
                  : ''
              }
            </a>
            <div class="ac-cart-upsell__meta">
              <a class="ac-cart-upsell__title" href="${p.url}">${p.title}</a>
              <p class="ac-cart-upsell__price">${formatMoney(priceCents)}</p>
              <button
                type="button"
                class="ac-cart-upsell__add"
                data-variant-id="${variant.id}"
              >Aggiungi</button>
            </div>
          </article>`;
      })
      .join('');

    root.hidden = false;
  }

  async function addToCart(variantId, button) {
    button.disabled = true;
    button.textContent = '…';
    try {
      const res = await fetch(window.Shopify?.routes?.root
        ? `${window.Shopify.routes.root}cart/add.js`
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add failed');
      button.textContent = 'Aggiunto';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      // Soft reload cart drawer section if theme supports it
      window.location.reload();
    } catch (_) {
      button.textContent = 'Riprova';
      button.disabled = false;
    }
  }

  function bindAddButtons(root) {
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-variant-id]');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn.dataset.variantId, btn);
    });
  }

  function initCartUpsells() {
    document.querySelectorAll('[data-ac-cart-upsell]').forEach((root) => {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      bindAddButtons(root);
      loadUpsell(root);
    });
  }

  /* ---------- Pre-checkout modal ---------- */
  function getCheckoutForm() {
    return document.getElementById('cart-form') || document.querySelector('form[action="/cart"]');
  }

  function proceedCheckout() {
    const form = getCheckoutForm();
    if (!form) {
      window.location.href = '/checkout';
      return;
    }
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'checkout';
    input.value = '';
    form.appendChild(input);
    form.submit();
  }

  function fillModalList(modal, products) {
    const list = modal.querySelector('[data-ac-precheckout-list]');
    if (!list) return;
    list.innerHTML = products
      .map((p) => {
        const imgRaw = p.featured_image || p.images?.[0];
        const img = typeof imgRaw === 'string' ? imgRaw : imgRaw?.src || '';
        const variant = p.variants?.find((v) => v.available) || p.variants?.[0];
        if (!variant) return '';
        const priceCents = Number(variant.price);
        return `
          <article class="ac-precheckout__item">
            <a class="ac-precheckout__media" href="${p.url}">
              ${img ? `<img src="${img}" alt="" width="96" height="120" loading="lazy">` : ''}
            </a>
            <div class="ac-precheckout__meta">
              <p class="ac-precheckout__item-title">${p.title}</p>
              <p class="ac-precheckout__price">${formatMoney(priceCents)}</p>
              <button type="button" class="ac-precheckout__add" data-variant-id="${variant.id}">Aggiungi</button>
            </div>
          </article>`;
      })
      .join('');
  }

  async function openPreCheckout(modal) {
    const seed =
      modal.dataset.productId ||
      document.querySelector('[data-ac-cart-upsell]')?.dataset.productId;
    if (!seed) {
      proceedCheckout();
      return;
    }

    const inCart = (
      document.querySelector('[data-ac-cart-upsell]')?.dataset.cartProductIds || ''
    ).split(',').filter(Boolean);

    let products = filterOutCart(
      await fetchRecommendations(seed, 'complementary', 6),
      inCart
    );
    if (products.length < 2) {
      products = filterOutCart(await fetchRecommendations(seed, 'related', 6), inCart);
    }
    products = products.slice(0, 3);

    if (!products.length) {
      proceedCheckout();
      return;
    }

    fillModalList(modal, products);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ac-precheckout-open');
  }

  function closePreCheckout(modal) {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ac-precheckout-open');
  }

  function initPreCheckout() {
    const modal = document.querySelector('[data-ac-precheckout]');
    if (!modal || modal.dataset.bound) return;
    modal.dataset.bound = '1';

    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest('.cart__checkout-button, #checkout, [name="checkout"]');
        if (!btn || btn.closest('[data-ac-precheckout]')) return;
        if (sessionStorage.getItem('ac_precheckout_seen') === '1') return;

        e.preventDefault();
        e.stopPropagation();
        openPreCheckout(modal);
      },
      true
    );

    modal.addEventListener('click', (e) => {
      if (e.target.matches('[data-ac-precheckout-close], [data-ac-precheckout-skip]')) {
        sessionStorage.setItem('ac_precheckout_seen', '1');
        closePreCheckout(modal);
        if (e.target.matches('[data-ac-precheckout-skip]')) proceedCheckout();
      }
      const add = e.target.closest('[data-variant-id]');
      if (add) {
        e.preventDefault();
        addToCart(add.dataset.variantId, add).then(() => {
          sessionStorage.setItem('ac_precheckout_seen', '1');
        });
      }
    });

    modal.querySelector('[data-ac-precheckout-continue]')?.addEventListener('click', () => {
      sessionStorage.setItem('ac_precheckout_seen', '1');
      closePreCheckout(modal);
      proceedCheckout();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCartUpsells();
      initPreCheckout();
    });
  } else {
    initCartUpsells();
    initPreCheckout();
  }

  document.addEventListener('shopify:section:load', () => {
    initCartUpsells();
    initPreCheckout();
  });
})();
